import { render } from "./PdfCard.vue?vue&type=template&id=438a7d1f&scoped=true"
import script from "./PdfCard.vue?vue&type=script&lang=js"
export * from "./PdfCard.vue?vue&type=script&lang=js"

import "./PdfCard.vue?vue&type=style&index=0&id=438a7d1f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438a7d1f"]])

export default __exports__